import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NAV_ITEMS } from '@/constants';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const isHome = location.pathname === '/';
  const light = !isHome || scrolled || open;

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-colors duration-500 ${
        light ? 'bg-white text-neutral-900 border-b border-neutral-200' : 'bg-transparent text-white'
      }`}
    >
      <div className="flex items-center justify-between px-5 md:px-10 h-16 md:h-20">
        <Link
          to="/"
          onClick={() => setOpen(false)}
          className="flex items-center whitespace-nowrap"
          aria-label="AM Estudio — Inicio"
        >
          <img
            src="https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/6c598d678e92210efe7f9c93b8522392.jpeg"
            alt="AM Estudio"
            className="h-10 md:h-12 w-auto"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              onClick={() => setOpen(false)}
              className="overline text-[0.68rem] whitespace-nowrap u-link hover:opacity-70 transition-opacity"
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Link
            to="/#contacto"
            className="inline-flex items-center gap-2 whitespace-nowrap px-5 py-2.5 text-xs font-medium uppercase tracking-[0.15em] border border-current hover:bg-current transition-colors group"
          >
            <span className="group-hover:text-white transition-colors">Cotizar proyecto</span>
          </Link>
        </div>

        <button
          type="button"
          aria-label="Abrir menú"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden w-10 h-10 flex items-center justify-center"
        >
          <i className={`ri-${open ? 'close' : 'menu'}-line text-2xl`}></i>
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white text-neutral-900 border-t border-neutral-200">
          <nav className="flex flex-col px-5 py-6">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className="py-4 border-b border-neutral-100 font-display text-2xl tracking-tightest"
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/#contacto"
              onClick={() => setOpen(false)}
              className="mt-6 inline-flex items-center justify-center gap-2 whitespace-nowrap px-5 py-4 text-xs font-medium uppercase tracking-[0.15em] bg-neutral-900 text-white"
            >
              Cotizar proyecto
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}